import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Hurricane02 = function Hurricane02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18 12c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6m12 0c0-3.3137-2.6863-6-6-6s-6 2.6863-6 6m12 0c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8m4 0c0-4.4183 3.5817-8 8-8s8 3.5817 8 8m-9 0c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default Hurricane02;